import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSites } from '../../../context/SiteContext';

export default function NewSitePage() {
  const { createSite } = useSites();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [domain, setDomain] = useState('');
  const [industry, setIndustry] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const site = await createSite(name, domain, { industry, status: 'pending' });
      navigate(`/sites?added=${site.id}`, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : '创建失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-xl">
      <h1 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <span className="w-1.5 h-5 rounded-sm bg-accent-500" />
        添加统计
      </h1>
      <p className="mt-2 text-sm text-foreground-600">
        填写网站名称和域名，保存后即可获取统计代码。有访问前会显示「等待添加网站」。
      </p>

      <form
        onSubmit={handleSubmit}
        className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6 flex flex-col gap-4"
      >
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">网站名称</span>
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="例如：合集电子模拟器"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent-300"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">域名</span>
          <input
            required
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="例如：ppgg5.top"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent-300"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">行业（选填）</span>
          <input
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            placeholder="博客 / 电商 / 工具 / 推广"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent-300"
          />
        </label>
        {error && <p className="text-sm text-primary-700">{error}</p>}
        <div className="flex items-center gap-3">
          <button
            type="submit"
            disabled={submitting}
            className="px-5 py-3 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-md disabled:opacity-60"
          >
            {submitting ? '保存中…' : '添加统计'}
          </button>
          <Link to="/sites" className="text-sm text-foreground-600 hover:text-primary-600">
            返回列表
          </Link>
        </div>
      </form>
    </div>
  );
}
